<template>
  <div class="topbar-date note">
    {{ $t('filter.today') + ' ' + datelabel }}
  </div>
</template>

<script>
import dayjs from 'dayjs';
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getLanguageCode'
    ]),
    datelabel: function () {
      const languageCode = this.getLanguageCode;
      return dayjs().locale(languageCode).format('DD MMMM YYYY');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/variables.scss';

.topbar-date {
  padding-top: $sp-margin-smaller;
  padding-bottom: $sp-margin-smaller;
  @media (min-width: $breakpoint) {
    border-left: 1px solid $white-trans6;
    padding-left: $sp-margin-small;
    padding-top: 0;
    padding-bottom: 0;
  }
  [controlsBg='light'] & {
    border-color: $black-trans6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/controlsbar/ControlsDate.vue